//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import React from 'react';

import _                       from 'lodash';
import { bindActionCreators }  from 'redux';
import { connect }             from 'react-redux';
import ComponentHelper         from '@/helper/ComponentHelper';
import StatelessCookieBanner   from '@/components/stateless/composed/CookieBanner';
import { CookieBannerActions } from '@/store/actions/cookieBanner';
import PropTypes               from '@/components/PropTypes';

export class Component extends React.Component {
    acceptCookiesClicked = () => {
        this.props.acceptCookies();
    };

    rejectedCookiesClicked = () => {
        this.props.rejectedCookies();
    };

    render() {
        const { cookiesAccepted } = this.props;

        return (
            <StatelessCookieBanner
                cookiesAccepted={cookiesAccepted}
                cookiesAcceptedClicked={this.acceptCookiesClicked}
                cookiesRejectedClicked={this.rejectedCookiesClicked}
            />
        );
    }

    shouldComponentUpdate(nextProps, nextState) {
        return ComponentHelper.shouldComponentUpdate(
            this,
            nextProps,
            nextState,
        );
    }
}

export const CookieBanner = Component;

Component.propTypes = {
    acceptCookies:   PropTypes.func,
    cookiesAccepted: PropTypes.bool,
    rejectedCookies: PropTypes.func,
};

Component.defaultProps = {
    acceptCookies:   _.noop,
    cookiesAccepted: null,
    rejectedCookies: _.noop,
};

Component.renderAffectingProps = Object.keys(Component.defaultProps);

Component.renderAffectingStates = [];

const mapStateToProps = (state) => (
    {
        cookiesAccepted: state.cookieBanner.accepted,
    }
);

const mapDispatchToProps = (dispatch) => bindActionCreators(
    CookieBannerActions,
    dispatch,
);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Component);
